/**
 * Merge a media asset row pushed by the API (ND-2453) onto the row a client holds.
 *
 * The pushed row is the list row minus the transcript keys of meta_data, which are
 * too large for a broadcast. meta_data is merged key by key so a status change lands
 * without dropping the transcript already held; every other field is replaced.
 */
export function mergeMediaAssetRow(held, incoming) {
  if (!held) return incoming

  const merged = { ...held, ...incoming }

  if (incoming.meta_data && held.meta_data) {
    merged.meta_data = { ...held.meta_data, ...incoming.meta_data }
  }

  return merged
}
